import { MotionConfig } from 'framer-motion';

export const Config = ({ children }: React.PropsWithChildren) => (
  <MotionConfig reducedMotion="user">{children}</MotionConfig>
);
